import { motion } from "framer-motion";
import ChapterMarker from "../ChapterMarker";
import Marquee from "../Marquee";
import { SKILLS, SECTIONS } from "../../data/content";

export default function Skills() {
  const s = SECTIONS[4];
  return (
    <section
      id={s.id}
      style={{ minHeight: `${s.weight * 100}vh` }}
      className="relative flex flex-col justify-center gap-10 px-6 md:px-12 lg:px-24 py-24"
      data-testid="section-skills"
    >
      <ChapterMarker number={s.number} label={s.label} />

      <div className="pointer-events-auto grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl">
        {SKILLS.categories.map((cat, i) => (
          <motion.div
            key={cat.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.5, delay: i * 0.06 }}
            className="border border-[#01FFFF]/15 bg-[#0A0A12]/60 backdrop-blur-xl p-6"
            data-testid={`skill-category-${i}`}
          >
            <h4 className="font-mono text-xs uppercase tracking-[0.3em] text-[#01FFFF]">
              {cat.name}
            </h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {cat.items.map((item) => (
                <span
                  key={item}
                  className="border border-[#8A9AAB]/25 px-3 py-1 font-mono text-[11px] text-[#E0E6ED]"
                >
                  {item}
                </span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>

      <div className="pointer-events-none mt-6 border-t border-b border-[#01FFFF]/10">
        <Marquee items={SKILLS.marquee} />
      </div>
    </section>
  );
}
